// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tr.editing td .product-name > div > div {\n  display: flex;\n  flex-direction: column;\n}\n", ""]);
// Exports
module.exports = exports;
